// extracted by mini-css-extract-plugin
export default {"footer":"layout-footer_footer__ip1wA","footerCondition":"layout-footer_footerCondition__1xD8g"};